export type UserSoundMasterSettings = {
  favoriteSounds: string[];
  soundHistories: string[];
  updatedAt: number;
};

export type UpdateUserSoundMasterSettings = Partial<UserSoundMasterSettings>;

export const UserSoundMasterSettingsRecord = (
  data: UpdateUserSoundMasterSettings
): UserSoundMasterSettings => {
  return {
    favoriteSounds: data.favoriteSounds || [],
    soundHistories: data.soundHistories || [],
    updatedAt: data.updatedAt || Date.now(),
  };
};
